import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: [],
  searchedProducts: [],
  loading: false,
  error: null,
};

export const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setAllProducts: (state, action) => {
      console.log('fetching all products...', action.payload);
      state.products = action.payload;
    },
    setSearchedProducts: (state, action) => {
      console.log('fetching searched products...', action.payload);
      state.searchedProducts = action.payload;
    },
    // Add more reducers for other actions related to products
  },
});

export const { setAllProducts, setSearchedProducts } = productSlice.actions;

export default productSlice.reducer;
